import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InterviewContext = createContext();

export const useInterview = () => useContext(InterviewContext);

export const InterviewProvider = ({ children }) => {
  const navigate = useNavigate();

  const [interviewData, setInterviewData] = useState(() => {
    // Load previous session from localStorage
    // const savedData = localStorage.getItem("interviewData");
    // return savedData
    //   ? JSON.parse(savedData)
    //   : {
    //       duration: 0,
    //       remainingTime: 0,
    //       isActive: false,
    //       transcription: "",
    //       chatHistory: [],
    //       session_id: "",
    //       memoryRules: [
    //         "Always answer in STAR format",
    //         "Keep responses concise",
    //       ],
    //       uploadedFiles: [],
    //       lastUpdated: Date.now(),
    //     };
    return {
      duration: 0,
      remainingTime: 0,
      isActive: false,
      transcription: '',
      chatHistory: [],
      session_id: '',
      memoryRules: ['Always answer in STAR format', 'Keep responses concise'],
      uploadedFiles: [],
      lastUpdated: Date.now(),
    };
  });

  // Save to localStorage when interviewData changes
  // useEffect(() => {
  //   localStorage.setItem("interviewData", JSON.stringify(interviewData));
  // }, [interviewData]);

  const updateInterviewData = (update) => {
    setInterviewData((prev) => {
      const newData = typeof update === 'function' ? update(prev) : { ...prev, ...update };
      return { ...newData, lastUpdated: Date.now() };
    });
  };

  // Auto-expire session if inactive for too long
  useEffect(() => {
    const now = Date.now();
    if (now - interviewData.lastUpdated > 24 * 60 * 60 * 1000) {
      console.log('Session expired. Clearing data.');
      // localStorage.removeItem("interviewData");
      navigate('/setup');
      setInterviewData({
        duration: 0,
        remainingTime: 0,
        isActive: false,
        transcription: '',
        chatHistory: [],
        session_id: '',
        memoryRules: ['Always answer in STAR format', 'Keep responses concise.'],
        uploadedFiles: [],
        lastUpdated: Date.now(),
      });
    }
  }, [interviewData.lastUpdated]);

  return (
    <InterviewContext.Provider value={{ interviewData, updateInterviewData }}>
      {children}
    </InterviewContext.Provider>
  );
};
